import type { OfferSearchRequestBodyWithSearchFormPassengers } from '@/types/purchase';
import type { SearchFormValues } from '@packages/webshop-search-widget';

type SearchOffersStopParams = Pick<
  OfferSearchRequestBodyWithSearchFormPassengers,
  | 'originStop'
  | 'destinationStop'
  | 'originGeoPosition'
  | 'destinationGeoPosition'
>;

export const buildSearchOffersStopParams = (
  origin: SearchFormValues['origin'],
  destination: SearchFormValues['destination']
): SearchOffersStopParams => {
  const originParams =
    origin?.type === 'address' && origin.geoPosition
      ? {
          originGeoPosition: {
            latitude: origin.geoPosition.latitude,
            longitude: origin.geoPosition.longitude,
            displayName: origin.label,
          },
        }
      : origin?.value
        ? {
            originStop: {
              code: origin.value,
            },
          }
        : {};

  const destinationParams =
    destination?.type === 'address' && destination.geoPosition
      ? {
          destinationGeoPosition: {
            latitude: destination.geoPosition.latitude,
            longitude: destination.geoPosition.longitude,
            displayName: destination.label,
          },
        }
      : destination?.value
        ? {
            destinationStop: {
              code: destination.value,
            },
          }
        : {};

  return {
    ...originParams,
    ...destinationParams,
  };
};
